module.exports = __webpack_public_path__ + "e21979550b1bf9888743e68a05cd411e.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/sp-directory-label/sp-directory-label.html
// module id = 1039
// module chunks = 0